import React from 'react';
import styled from 'styled-components';

import errorReporter from '@app/errorReporter';
import { Alert } from '@brokerbay/design-components';
import { UserSearch, ContactType, message, Text, Modal } from 'components';
import { ContactController } from 'api';
import { ContactDrawerContext } from '../../../contexts';

interface ChangeOwnerModalProps {
  contactId: string;
  contactName: string;
  onClose: () => void;
  visible: boolean;
}

interface ChangeOwnerModalState {
  fetching: boolean;
  selectedUser: ContactType | undefined;
  working: boolean;
  searchInput: string;
}

class ChangeOwnerModal extends React.Component<
  ChangeOwnerModalProps,
  ChangeOwnerModalState
> {
  declare context: React.ContextType<typeof ContactDrawerContext>;

  public constructor(props: ChangeOwnerModalProps) {
    super(props);

    this.state = {
      fetching: false,
      selectedUser: undefined,
      searchInput: '',
      working: false,
    };
  }

  public selectUser = (user: ContactType) => {
    this.setState({ selectedUser: user });
  };

  public deselectUser = () => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      this.setState({ selectedUser: undefined });
    }
  };

  private _changeOwner = async () => {
    const { selectedUser } = this.state;

    const { contactId, contactName, onClose } = this.props;

    const { closeContactDrawer, triggerReload } = this.context;

    try {
      this.setState({ working: true });
      await ContactController.changeOwner(contactId, selectedUser.id);
      this.setState({ working: false }, () => {
        onClose();
        closeContactDrawer();
        triggerReload();
      });
      message.success(
        `Ownership of ${contactName} has been transferred to ${selectedUser.firstName} ${selectedUser.lastName}`.trim(),
      );
    } catch (err) {
      message.error(
        `Could not change owner of ${contactName} to ${selectedUser.firstName} ${selectedUser.lastName}`.trim(),
      );
      errorReporter.error(err);
      this.setState({ working: false });
    }
  };

  public render() {
    const { selectedUser, working } = this.state;
    const { contactName, visible, onClose } = this.props;
    return (
      <Modal
        open={visible}
        title="Change Owner"
        cancelText="Cancel"
        onCancel={onClose}
        destroyOnClose
        okText="Change Owner"
        okButtonProps={{
          disabled: !selectedUser,
          loading: working,
        }}
        onOk={this._changeOwner}
        getContainer={false}
      >
        <StyledAlert
          message={
            <Text>
              Please select who you would like to transfer ownership of{' '}
              <Text strong>{contactName}</Text> to.
            </Text>
          }
          type="info"
          showIcon
        />
        <Text strong>Agent</Text>
        <UserSearch
          filterSelf
          onSelect={this.selectUser}
          onClear={this.deselectUser}
          selectedUser={selectedUser}
          type="brokerage"
          includeUnverified
        />
      </Modal>
    );
  }
}

ChangeOwnerModal.contextType = ContactDrawerContext;

export default ChangeOwnerModal;

const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;
